export default {
  get storageKeys() {
    return {
      allowCookies: 'likeshop-allow-cookies',
    };
  },
};
